/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
import React from 'react'

//system components
import './DVLASection.css'

const DVLASection = ({ labels, values }) => {
  return (
    <div className="dvla-section">
      <h2 className="section-title">DVLA VES Lookup</h2>
      <dl className="dvla-info-container">
        {Object.keys(labels).map((key) => (
          <div key={key} className="NoticeDetailRow">
            <dt>{labels[key]}</dt>
            <dd>{values[key]}</dd>
          </div>
        ))}
      </dl>
    </div>
  )
}

export default DVLASection
